const product_variants_slider_el = document.querySelector(".swiper.elkad-section-product-variants__slider");

if (product_variants_slider_el) {
  const swiper_product_variants = new Swiper(product_variants_slider_el, {
    slidesPerView: 1,
    spaceBetween: 20,
    draggable: true,
    autoHeight: true,
    navigation: {
      nextEl: '.elkad-section-product-variants__slider--next',
      prevEl: '.elkad-section-product-variants__slider--prev',
    },
    breakpoints: {
      767: {
        spaceBetween: 40
      }
    }
  });

  const allNavigationButtons = document.querySelectorAll(".elkad-section-product-variants__content--navigation");

  allNavigationButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      if (window.innerWidth > 767) {
        const slideIndex = btn.getAttribute("data-index");

        swiper_product_variants.slideTo(slideIndex);
      }
    });
  });

  let swiper_product_variants_content = {};
  swiper_product_variants_content.initialized = false;

  const initContentSlider = () => {
    const product_variants_content_el = document.querySelector(".swiper.elkad-section-product-variants__content");
    const allAccordionsInContent = document.querySelectorAll(".elkad-section-product-variants__content__slide__content collapsible-row");
    
    if (window.innerWidth < 700) {
      if (swiper_product_variants_content.initialized) return;
      
      swiper_product_variants_content = new Swiper(product_variants_content_el, {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        allowTouchMove: false,
        // autoHeight: true
      });

      allNavigationButtons.forEach(btn => {
        btn.closest("details").setAttribute("open", "");
      });

      // allAccordionsInContent.forEach(accordion => {
      //   accordion.addEventListener("click", () => {
      //     setTimeout(() => {
      //       product_variants_content_el.querySelector(".swiper-wrapper").style = '';
      //     }, 150);
      //   });
      // });

      swiper_product_variants.on('slideChange', function (e) {
        swiper_product_variants_content.slideTo(swiper_product_variants.activeIndex);
        if (swiper_product_variants.slides[swiper_product_variants.activeIndex].querySelector("video")) {
          swiper_product_variants.slides[swiper_product_variants.activeIndex].querySelector("video").play();
        }
      });
    } else {
      if (swiper_product_variants_content.initialized) {
        swiper_product_variants_content.destroy();
        allNavigationButtons.forEach(btn => {
          btn.closest("details").removeAttribute("open");
        });
      }
    }
  }

  window.addEventListener("resize", initContentSlider);
  initContentSlider();

  // // Call the function with the Swiper instance as a parameter
  // updateSwiperWrapperHeight(swiper_product_variants);

  // // Function to update the wrapper height based on the active slide
  // function updateSwiperWrapperHeight(swiper) {
  //   swiper.on('init slideChange', function () {
  //     var activeSlide = swiper.slides[swiper.activeIndex];
  //     var wrapper = swiper.wrapperEl;

  //     // Set the wrapper height to the active slide's height
  //     wrapper.style.height = activeSlide.offsetHeight + 'px';
  //   });
  // }
}